/*
  PortretArt: koszyk boczny.

  1) Uwagi do zamówienia: kilka zabezpieczeń naraz, żeby uwaga zawsze dotarła do zamówienia:
     - pole jest częścią formularza kasy (name="note", form="CartDrawer-Form"), więc idzie razem z „Przejdź do kasy”,
     - zapis do koszyka w trakcie pisania (0,6 s po ostatnim znaku) i od razu po wyjściu z pola,
     - przed przejściem do kasy czekamy na zapis (max 1,5 s),
     - przy zamknięciu/opuszczeniu strony niezapisana uwaga leci przez sendBeacon,
     - koszyk przerysowuje się po zmianie ilości: niezapisany tekst wraca do pola.

  2) Licznik wysyłki (.pa-cd): te same zasady co na kartach produktów.
     Zamówienie do godziny data-cutoff-hour w dzień roboczy = wysyłka tego dnia, później = następny dzień roboczy.
     data-extra-days: koszulki +1 dzień roboczy. Dostawa = dzień roboczy po wysyłce.
*/
(function () {
  var NOTE_IDS = ['CartDrawer-Note', 'Cart-note'];
  var pending = null; // tekst jeszcze niezapisany w koszyku
  var timer = null;
  var saving = null; // Promise trwającego zapisu

  function isNote(el) {
    return el && NOTE_IDS.indexOf(el.id) !== -1;
  }

  function updateUrl() {
    return (window.routes && window.routes.cart_update_url) || '/cart/update';
  }

  function setStatus(text, cls) {
    document.querySelectorAll('.pa-note__status').forEach(function (el) {
      el.textContent = text;
      el.classList.remove('is-saved', 'is-error');
      if (cls) el.classList.add(cls);
    });
  }

  function save() {
    clearTimeout(timer);
    timer = null;
    if (pending === null) return saving || Promise.resolve();
    var value = pending;
    setStatus('Zapisywanie…');
    saving = fetch(updateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: value }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .then(function (cart) {
        if (cart && String(cart.note || '').trim() !== value.trim()) throw new Error('note');
        if (pending === value) pending = null;
        if (pending === null) setStatus(value ? 'Uwaga zapisana ✓' : '', value ? 'is-saved' : null);
      })
      .catch(function () {
        setStatus('Nie udało się zapisać. Uwaga i tak trafi do zamówienia po kliknięciu „Przejdź do kasy”.', 'is-error');
      })
      .finally(function () {
        saving = null;
      });
    return saving;
  }

  document.addEventListener('input', function (e) {
    if (!isNote(e.target)) return;
    pending = e.target.value;
    setStatus('');
    clearTimeout(timer);
    timer = setTimeout(save, 600);
  });

  // Wyjście z pola = zapis od razu
  document.addEventListener(
    'blur',
    function (e) {
      if (isNote(e.target) && pending !== null) save();
    },
    true
  );

  // Przejście do kasy: najpierw dokończ zapis (max 1,5 s), potem dalej
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('#CartDrawer-Checkout, #checkout');
      if (!btn || btn.dataset.paReady) return;
      if (pending === null && !saving) return;
      e.preventDefault();
      e.stopPropagation();
      var done = false;
      function go() {
        if (done) return;
        done = true;
        btn.dataset.paReady = '1';
        btn.click();
      }
      save().then(go, go);
      setTimeout(go, 1500);
    },
    true
  );

  // Klient zamyka kartę albo przechodzi gdzie indziej w trakcie pisania
  window.addEventListener('pagehide', function () {
    if (pending === null || !navigator.sendBeacon) return;
    var data = new URLSearchParams();
    data.append('note', pending);
    navigator.sendBeacon(updateUrl() + '.js', data);
  });

  // Koszyk przerysowuje się po zmianie ilości: przywróć niezapisany tekst
  function watch() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;
    new MutationObserver(function () {
      var el = document.getElementById(NOTE_IDS[0]);
      if (el && pending !== null && el.value !== pending) el.value = pending;
      tick();
    }).observe(drawer, { childList: true, subtree: true });
  }

  /* ---------- Licznik wysyłki ---------- */
  var TZ = 'Europe/Warsaw';
  var WD_ACC = ['w niedzielę', 'w poniedziałek', 'we wtorek', 'w środę', 'w czwartek', 'w piątek', 'w sobotę'];
  var tzFmt = window.Intl ? new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
  }) : null;

  function two(n) {
    return String(n).padStart(2, '0');
  }
  function nowTZ() {
    var p = tzFmt.formatToParts(new Date()).reduce(function (a, x) {
      a[x.type] = x.value;
      return a;
    }, {});
    var h = p.hour === '24' ? '00' : p.hour;
    return new Date(p.year + '-' + p.month + '-' + p.day + 'T' + h + ':' + p.minute + ':' + p.second);
  }
  function ymd(d) {
    return d.getFullYear() + '-' + two(d.getMonth() + 1) + '-' + two(d.getDate());
  }
  function dayLabel(now, day) {
    var t1 = new Date(now);
    t1.setDate(t1.getDate() + 1);
    var t2 = new Date(now);
    t2.setDate(t2.getDate() + 2);
    if (ymd(day) === ymd(now)) return 'dziś';
    if (ymd(day) === ymd(t1)) return 'jutro';
    if (ymd(day) === ymd(t2)) return 'pojutrze';
    return WD_ACC[day.getDay()];
  }

  function plan(box) {
    var cutHour = Number(box.getAttribute('data-cutoff-hour')) || 11;
    var extra = Math.max(0, Number(box.getAttribute('data-extra-days')) || 0);
    var hol = {};
    (box.getAttribute('data-holidays') || '').split(',').forEach(function (s) {
      if (s) hol[s.trim()] = true;
    });
    function isBiz(d) {
      var w = d.getDay();
      return w !== 0 && w !== 6 && !hol[ymd(d)];
    }
    function nextBiz(from) {
      var d = new Date(from);
      d.setDate(d.getDate() + 1);
      while (!isBiz(d)) d.setDate(d.getDate() + 1);
      return d;
    }

    var now = nowTZ();
    var cut = new Date(now);
    cut.setHours(cutHour, 0, 0, 0);
    var orderDay, deadline;
    if (isBiz(now) && now < cut) {
      orderDay = new Date(now);
      deadline = cut;
    } else {
      orderDay = nextBiz(now);
      deadline = new Date(orderDay);
      deadline.setHours(cutHour, 0, 0, 0);
    }
    var ship = orderDay;
    for (var i = 0; i < extra; i++) ship = nextBiz(ship);
    return { now: now, left: Math.max(0, deadline - now), ship: ship, delivery: nextBiz(ship) };
  }

  function tick() {
    if (!tzFmt) return;
    document.querySelectorAll('.pa-cd').forEach(function (box) {
      var text = box.querySelector('.pa-cd__text');
      if (!text) return;
      var p = plan(box);
      var s = Math.floor(p.left / 1000);
      var time = two(Math.floor(s / 3600)) + ':' + two(Math.floor((s % 3600) / 60)) + ':' + two(s % 60);
      // Ponad doba do granicy (np. piątek po 11:00): bez długiego licznika
      var lead = p.left > 86400000 ? 'Zamów teraz, ' : 'Zamów w ciągu <strong class="pa-cd__time">' + time + '</strong>, ';
      var html =
        lead +
        'wyślemy <strong>' + dayLabel(p.now, p.ship) + '</strong>' +
        '<span class="pa-cd__del">Planowana dostawa: ' + dayLabel(p.now, p.delivery) + '</span>';
      if (text.innerHTML !== html) text.innerHTML = html;
      box.classList.toggle('is-soon', p.left <= 3600000 && ymd(p.ship) === ymd(p.now));
    });
  }

  function init() {
    watch();
    tick();
    setInterval(tick, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
